import React, { Component } from 'react';

import styles from './default.less';

type Styles = {
	label?: string;
	checkedLabel?: string;
	radio?: string;
	disabledLabel?: string;
	checkedDisabledLabel?: string;
	likeradio?: string;
};

interface Props {
	id?: string;
	name: string;
	children: React.ReactNode;
	checked: boolean;
	disabled: boolean;
	styles: Styles;
	onChange(): void;
}

export default class Radio extends Component<Props> {
	static defaultProps = {
		checked: false,
		disabled: false,
		styles,
	};

	render() {
		const { id, name, children, checked, disabled, onChange, styles } = this.props;
		const className = checked
			? disabled
				? styles.checkedDisabledLabel
				: styles.checkedLabel
			: disabled
			? styles.disabledLabel
			: styles.label;

		return (
			<label className={className} htmlFor={id}>
				<input
					className={styles.radio}
					disabled={disabled}
					checked={checked}
					id={id}
					name={name}
					type='radio'
					onChange={onChange}
				/>
				<i className={styles.likeradio} />
				{children}
			</label>
		);
	}
}
